import ItemUomOverrideService from '@/services/admin/itemUomOverride.service'

const state = {
}

const getters = {
}

const actions = {
    async getUomOverrideList({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemUomOverrideService.getList(payload)
            return result
        } catch (e) {
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async saveUomOverride({commit}, payload) {
        try {
            commit('setLoading', true, { root: true })
            commit('clearError', null, { root: true })
            const result = await ItemUomOverrideService.save(payload)
            return result
        } catch (e) {
            return e
        } finally {
            commit('setLoading', false, { root: true })
        }
    },
    async syncUomOverrides({commit}) {
        try {
            const result = await ItemUomOverrideService.sync()
            return result
        } catch (e) {
            return e
        }
    },
}

const mutations = {
}

export const adminItemUomOverride = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
